<template>
  <Teleport to="header">
    <div class="my-2">
      <ProductTimer />
    </div>
  </Teleport>

  <div class="container flex w-full flex-col lg:flex-row lg:gap-5">
    <div class="order-2 hidden w-full lg:order-1 lg:block lg:w-3/5">
      <ConfiguratorImageGallery v-if="isConfiguratorPage" />
      <CollectionImageGallery v-else />
    </div>

    <div
      id="configurator-container-wrapper"
      class="order-3 flex h-fit w-full flex-col rounded-xl lg:w-2/5 lg:border lg:border-gray-ultralight lg:p-5"
    >
      <PageTitle />

      <div class="mt-3 block w-full lg:hidden lg:w-3/5">
        <ConfiguratorImageGallery v-if="isConfiguratorPage" />
        <CollectionImageGallery v-else />
      </div>

      <!-- Show configurator pages -->
      <ProductConfigurator v-if="isConfiguratorPage" />

      <!-- Show collection pages -->
      <ProductCollection v-else-if="hasEndProducts" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import ProductCollection from '@/pages/ProductPage/ProductCollection.vue';
import ProductConfigurator from '@/pages/ProductPage/ProductConfigurator.vue';
import { MediaclipProductType } from '@/types/Mediaclip/MediaclipProductType';
import { computed, ComputedRef } from 'vue';
import '@/types/window';
import ProductTimer from '@/components/ProductTimer.vue';
import ConfiguratorImageGallery from '@/pages/ProductPage/partials/ProductDetailPage/ConfiguratorImageGallery.vue';
import CollectionImageGallery from '@/pages/ProductPage/partials/ProductDetailPage/CollectionImageGallery.vue';
import PageTitle from '@/pages/ProductPage/partials/ProductDetailPage/PageTitle.vue';
const mediaclipType = Number(window.product.mediaclip_product_type.valueOf());
const isConfiguratorPage: ComputedRef<boolean> = computed(() =>
  [
    MediaclipProductType.CONFIGURATOR,
    MediaclipProductType.SIMPLE,
    MediaclipProductType.LETTERCOLLAGE,
  ].includes(mediaclipType)
);

const hasEndProducts: ComputedRef<boolean> = computed(
  () => !!window.end_products?.length
);
</script>
